import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';

export default function () {

  $('#request-rep-submit').on('click', function() {

    $('form[name="request-a-rep"]').validate({
      rules: {
        title: {
          required: true
        },
        firstName: {
          minlength: 2,
          required: true
        },
        lastName: {
          minlength: 2,
          required: true
        },
        zip: {
          digits: true,
          minlength: 5,
          maxlength: 5,
          required: true
        },
        phone: {
          phoneUS: true,
          required: true
        },
        email: {
          email: true,
          required: true
        }
      },
      submitHandler: function() {
        $.ajax({
          method: 'POST',
          url: '../rep-request.php',
          data: {
            title: $('#title')[0].value,
            firstName: $('#firstName')[0].value,
            lastName: $('#lastName')[0].value,
            zip: $('#zip')[0].value,
            phone: $('#phone')[0].value,
            email: $('#email')[0].value
          },
          success: function() {
            console.log('POST Succeeded');
            // show successful modal
            $('#modal-request-rep').modal('hide');
            $('#modal-request-rep form').trigger('reset');
            $('#modal-response .modal-body').html('<h1>Thank You</h1><p>Your contact information has been submitted.</p>');
            $('#modal-response').modal('show');
          },
          error: function(response) {
            console.error('POST Failed: ' + JSON.stringify(response));
            // show unsuccessful modal
            $('#modal-request-rep').modal('hide');
            $('#modal-response .modal-body').html('<h1>Our Apologies</h1><p>Your information was not submitted successfully. Please try resubmitting the contact form. Thank you!</p>');
            $('#modal-response').modal('show');
          }
        });
      }
    });
  });

}


// WEBPACK FOOTER //
// ./js/modules/request-rep-modal.js